import OrganisationList from "./components/List"
import OrganisationForm from "./components/Form"
import OrganisationView from "./components/View"

let module = "organisations"

export default [
  {
    path: "organisations",
    component: OrganisationList,
    meta: { module: module, permissions: ["organisation-access"] }
  },
  {
    path: "organisations/create",
    component: OrganisationForm,
    props: true,
    meta: { module: module, permissions: ["organisation-create"] }
  },
  {
    path: "organisations/edit/:id",
    component: OrganisationForm,
    props: true,
    meta: { module: module, permissions: ["organisation-edit"] }
  },
  {
    path: "organisations/view/:id",
    component: OrganisationView,
    props: true,
    meta: { module: module, permissions: ["organisation-access"] }
  }
]
